export enum BannerType {
  'EVENT' = 'EVENT',
  'CHALLENGE_HEADER' = 'CHALLENGE_HEADER',
  'CHALLENGE_BG' = 'CHALLENGE_BG',
  'BADGE' = 'BADGE',
  'STICKER' = 'STICKER',
  'HALL_PASS' = 'HALL_PASS',
}
